<template>
        <div class="has-text-centered has-text-white scrollableY">
            <div class="container">
                 <div class="bottom20">&nbsp;</div>
                <H1 class="has-text-white is-size-3"><img src="@/assets/img/fourDotsLogo.png" width="24"/> PLANS <i v-if="DEBUG" @click="fill" class="fa fa-arrow-down"></i></H1>
                <div class="wideLimitWidth2 top10 marginAutod has-text-centered">
                    
                    <div  class="has-text-left">
    
                        <h2 class="top40 has-text-centered"><b class="is-size-4">Please choose a plan.</b><br><b>You can get started for free!</b></h2>
                        <div class="columns has-text-left top20">
                            <div class="column is-flex">
                                <div class="paidPlans" @click="act(plans[0].code)" >
                                    <div class="planName"><b>{{plans[0].name}}</b></div>
                                    <!-- <div class="planPrice top10">{{plans[0].price}}/{{plans[0].units}}</div> -->
                                    <!-- <button v-show="plan != 'free'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                    <!-- <div v-show="plan == 'free'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                  
                                    <div class="planPrice top10">Like we said, free!</div>
                                    <div class="top10">&bull; {{getPlanBundleLimit('free')}} bundle limit</div>
                                    <div >&bull; {{getPlanCardLimit('free')}} miimu limit</div>
                                    <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20" >SELECT</button></div>
                                </div>
                            </div>
                            <div class="column is-flex">
                                <div class="paidPlans" @click="act(plans[1].code)" >
                                    <div class="planName"><b>{{plans[1].name}}</b></div>
                                    <div class="planPrice top10">{{plans[1].price}}/{{plans[1].units}}</div>
                                    <div class="top10">&bull; Unlimited bundles</div>
                                    <div >&bull; Unlimited miimus</div>
                                    <div >&bull; Collab bundles</div>
                                    <div >&bull; Hide Ads</div>
                                    <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20">SELECT</button></div>
                                    <!-- <button v-show="plan != 'monthly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                   <!--  <div v-show="plan == 'monthly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                </div>
                            </div>
    
                            <div class="column is-flex">
                                <div class="paidPlans" @click="act(plans[2].code)" >
                                    <div class="bValue">Best Value</div>
                                    <div class="planName"><b>{{plans[2].name}}</b></div>
                                    <div class="planPrice top10">{{plans[2].price}}/{{plans[2].units}}</div>
                                    <div class="top10">&bull; Unlimited bundles</div>
                                    <div >&bull; Unlimited miimus</div>
                                    <div >&bull; Collab bundles</div>
                                    <div >&bull; Hide Ads</div>
                                    <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20">SELECT</button></div>
                                    
                                    <!--  <button v-show="plan != 'yearly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                    <!-- <div v-show="plan == 'yearly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                </div>
                            </div>
                        </div>
    
                       
                    </div>
                </div>
    
               
            </div>
            <footerdiv class="top160"></footerdiv>
        </div>
</template>

<script>


import countries from '../static/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';
import Footerdiv from '../components/Footer.vue'

export default {
    components: {Footerdiv},
    data: function(){
        

        return{
            initialized: false,
            // info: {src: {cardNumber: 4545}, billing: {firstName: 'First', lastName: "Last", address: 'Street Name', city: 'City', state: 'State', zip: 'Zip', country: 'US'}},
            countries,
            // total: 3.19, //this.$root.app.checkoutTotal[0],
            // hasGwId: true,//this.$root.app.checkoutTotal[1],
            az: az,
            showErrors: false,
            // dl: '',
           
            inited: false,


            plans: null,
           

            DEBUG: false
        }
    },
    filters: {
        countryFromCode: function (value) {
            if (!value) return '';
            value = value.toString();
            for(var i=0; i < countries.length; i++){
                if(value == countries[i].code){
                    return countries[i].name;
                }
            }
            return ''
        }
    },

    mounted: async function(){
        const self = this

        if(this.$root.app.doneFederating){
            //this.initialize();
        }
        AZEventBus.$once('onFederate', msg => {
            //this.initialize();
        });

        // Load plans.  Don't need to wait for federating.
        // TODO might want to combine this with other requests
        // to minimize number of lambda calls.
        this.$root.app.apiClient.get('open/confirm/plans', {}, (plans) => {
            self.plans = plans;
        }, (e) => {
            console.log(e);
        });

        // Initialize Stripe
        if(!this.$root.app.inApp)
            this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY);
        
    },
    methods:{
       /*  initialize: function() {
            if (this.initialized) {
                return
            }

            // Load user plan info.
            this.$root.app.apiClient.get('auth/account/subinfo', {}, (res) => {
               
                
              
               
               
            }, (e) => {
                console.log(e);
            });

            this.initialized = true;
        }, */

        act: function(plan){
            if(this.$root.app.isAuth){
                this.$root.app.showModalOK({message: 'To manage your current plan please visit your Account page. Would you like to go there now?', callBack: this.goToAccount})
                return
            }

            this.$root.app.autoSelectPlan = plan
            if(!this.$root.app.isAuth){
                this.$router.push('/register')
            }
           
        },  

        goToAccount: function(){
            this.$router.push('/accsettings')
        },
       
        getPlanBundleLimit() {
            let bundleLimit = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        bundleLimit = p.bundleLimit;
                        break;
                    }
                }
            }

            return bundleLimit != null ? bundleLimit : 20;
        },
        getPlanCardLimit() {
            let cardLimit = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        cardLimit = p.cardLimit;
                        break;
                    }
                }
            }

            return cardLimit != null ? cardLimit : 200;
        },
        hasUpgraded() {
            return this.$root.app.userAttrs.hasUpgraded === true;
        },

        fill() {
            this.planForm.address1 = '123 Main St.';
            this.planForm.city = 'Denver';
            this.planForm.state = 'CO';
            this.planForm.zip = '12345';
            this.planForm.country = 'US';
            this.planForm.nameOnCard = 'John Smith';
        }
    }
}
</script>
